import { ApolloError } from 'apollo-client';
import { AmberHoc, AmberHocProps } from '../../../util';
import {withGetPromptFanGuidanceExtension as HOC} from '../__generated';

export type WithGetPromptFanGuidanceExtensionHocOwnProps = {
    grain_bin_id: number,
    loading?: boolean;
    onError?: (error: ApolloError) => void;
};
export type WithGetPromptFanGuidanceExtensionHocChildProps = {
    get_prompt_fan_guidance_extension_loading: boolean;
    prompt_fan_guidance_extension: boolean | any;
    refetch_prompt_fan_guidance_extension: () => Promise<any>;
};

export const withGetPromptFanGuidanceExtensionHoc: AmberHoc<
    WithGetPromptFanGuidanceExtensionHocOwnProps,
    WithGetPromptFanGuidanceExtensionHocChildProps
    > = (component) =>
    HOC<
        AmberHocProps<
            WithGetPromptFanGuidanceExtensionHocOwnProps,
            WithGetPromptFanGuidanceExtensionHocChildProps,
            typeof component
            >,
        WithGetPromptFanGuidanceExtensionHocChildProps
        >({
        options: ({ grain_bin_id, onError }) => ({
            onError,
            errorPolicy: onError ? 'all' : 'none',
            fetchPolicy: 'network-only',
            variables: { grain_bin_id },
            notifyOnNetworkStatusChange: true,
        }),
        props: ({ data, ownProps: { loading } }) => {
            if (!data || data.loading) {
                return {
                    get_prompt_fan_guidance_extension_loading: true,
                    refetch_prompt_fan_guidance_extension: () => Promise.resolve(),
                    prompt_fan_guidance_extension: false,
                };
            }
            return {
                get_prompt_fan_guidance_extension_loading: loading || false,
                refetch_prompt_fan_guidance_extension: data.refetch,
                prompt_fan_guidance_extension: data.prompt_fan_guidance_extension || false,
            };
        },
    })(component as any);
